/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { LiveManagementCreateLivecarpItemRequest } from './LiveManagementCreateLivecarpItemRequest';

export type LiveManagementEditLivecarpRequest = {
    id: number;
    title?: string;
    titleEn?: string;
    titleCn?: string;
    startDatetime?: string;
    endDatetime?: string;
    thumbnailNo?: number;
    isUploadThumbnails?: boolean;
    imageId?: number;
    context: string;
    contextEn?: string | null;
    contextCn?: string | null;
    postDate?: string;
    openStatus?: LiveManagementEditLivecarpRequest.openStatus;
    releaseSetting?: LiveManagementEditLivecarpRequest.releaseSetting;
    livecarpItems?: Array<LiveManagementCreateLivecarpItemRequest>;
};

export namespace LiveManagementEditLivecarpRequest {

    export enum openStatus {
        EDIT = 'edit',
        RELEASE = 'release',
        CANCEL = 'cancel',
    }

    export enum releaseSetting {
        NOW = 'now',
        DATE = 'date',
    }


}

